import { useQuery } from "@tanstack/react-query";
import { settingsService } from "../services/settingsService";
import { useSettingsStore } from "../context/useSettingsStore";
import { userStore } from "../store/userStore";

export const useGetSetting = () => {
  const {
    setTicketService,
    setConfectioneryService,
    setMaxSeats,
    setMembershipValue,
    setMembershipService,
  } = useSettingsStore.getState();

  return useQuery({
    queryKey: ["settings"],
    queryFn: async () => {
      try {
        const response = await settingsService.getSettings();
        const { data } = response;
        const setters = {
          ticket_servicio: setTicketService,
          confiteria_servicio: setConfectioneryService,
          maximo_entradas: setMaxSeats,
          membresia_valor: setMembershipValue,
          membresia_servicio: setMembershipService,
        };

        data.data.forEach(({ key, value }) => {
          const setter = setters[key];
          if (setter) {
            setter(parseInt(value));
          }
        });
        return data.data;
      } catch (error) {
        console.error(error);
      }
    },
  });
};

export const useGetBanners = () => {
  const kioskData = userStore((state) => state.kioskData);
  const theater = kioskData.complement.theater.name || "viziona";

  return useQuery({
    queryKey: ["banners"],
    queryFn: async () => {
      const { data } = await settingsService.getBanners(theater);
      return data.data;
    },
  });
};
